import { z } from 'zod';
import { BaseMaterialQuoteSchema } from './material-quote.ts';

export const InternalMaterialPostQuoteRequestSchema = BaseMaterialQuoteSchema.and(
    z.object({
        payload: z.object({
            // add custom fields of the fulfillment channel here
            type: z.string().nullish(),
            isDangerous: z.boolean().nullish(),
        }),
    })
);

export type InternalMaterialPostQuoteRequest = z.input<typeof InternalMaterialPostQuoteRequestSchema>;
